import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import Loader from '../framework/loader';

const Submit = ({
	className = null,
	ignore_dirty,
	name,
	size = 'lg',
	variant = 'primary',
}) => {
	const { dirty, isSubmitting, isValid, isValidating } = useFormikContext();
	let disabled = !dirty || isSubmitting || !isValid || isValidating;
	if (ignore_dirty) {
		disabled = isSubmitting || !isValid || isValidating;
	}

	const sizes = { lg: 'btn-lg', md: '', sm: 'btn-sm' };
	const variants = {
		dark: 'btn-dark',
		light: 'btn-light',
		primary: 'btn-primary',
	};

	return (
		<div className="">
			<button
				className={`btn ${variants[variant]} rounded-pill position-relative w-100 ${sizes[size]} ${className}`}
				disabled={disabled}
				onMouseDown={(event) => {
					event.preventDefault();
				}}
				type="submit"
			>
				{name}

				{(isSubmitting || isValidating) && (
					<>
						<div className="btn-loader">
							<Loader color="light" />
						</div>
					</>
				)}
			</button>
		</div>
	);
};

Submit.propTypes = {
	className: PropTypes.string,
	ignore_dirty: PropTypes.bool,
	name: PropTypes.string,
	size: PropTypes.string,
	variant: PropTypes.string,
};

export default Submit;
